import React, { useEffect, useState } from 'react';
import { BiChevronRight } from 'react-icons/bi';
import moment from 'moment';
import '../../../styles/Admin/admin_alumni.css';
import '../../../styles/Admin/adminDashboard.css';
import '../../../styles/Admin/admin_announcement.css';
import { useNavigate } from 'react-router-dom';

export default function Admin_Events({ events, fetchEventById }) {
    const [searchOption, setSearchOption] = useState('name');
    const navigate = useNavigate();
    const { clientWidth } = document.body;

    useEffect(() => {
        // 👇️ apply a class to main top nav bar to hide it
        let mainNavBar = document.querySelector('._3drDv.MainNavBar');
        if (mainNavBar) mainNavBar.style.display = 'none';

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className='admin-alumni admin-announcement'>
            <h1 className='admin-alumni-header'>All Events</h1>

            <div className='admin-alumni-search-box-container'>
                <input
                    type='search'
                    className='admin-alumni-search-box'
                    name='search'
                    placeholder={`search here by ${searchOption}...`}
                />
            </div>

            <span className='admin-alumni-search-options-header'>Search by:</span>
            <div className='admin-alumni-search-options-container'>
                <label htmlFor='radio-name'>
                    {' '}
                    Name
                    <input
                        type='radio'
                        name='radio-name'
                        id='radio-name'
                        onChange={() => setSearchOption('name')}
                        checked={searchOption === 'name' ? true : false}
                    />
                </label>
                <label htmlFor='radio-details'>
                    Details
                    <input
                        type='radio'
                        name='radio-details'
                        id='radio-details'
                        onChange={() => setSearchOption('details')}
                        checked={searchOption === 'details' ? true : false}
                    />
                </label>
                <label htmlFor='radio-priority'>
                    Priority
                    <input
                        type='radio'
                        name='radio-priority'
                        id='radio-priority'
                        onChange={() => setSearchOption('priority')}
                        checked={searchOption === 'priority' ? true : false}
                    />
                </label>
            </div>

            <div className='admin-dashboard-content'>
                <div className='admin-dashboard-content-alumni'>
                    <div className='alumni-header-container'>
                        <span className='alumni-header-text'>Events Table</span>

                        <button
                            className='add-btn'
                            onClick={() => navigate('/admin.console/events/new')}
                        >
                            {clientWidth < 576 ? '+' : 'Add Event'}
                        </button>
                    </div>

                    <div className='alumni-table-container'>
                        <table style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th>id</th>
                                    <th>uuid</th>
                                    <th>name</th>
                                    <th>color</th>
                                    <th>start date</th>
                                    <th>end date</th>
                                    <th>subscribers</th>
                                    <th>details</th>
                                    <th>priority</th>
                                    <th>posted on</th>
                                </tr>
                            </thead>
                            <tbody>
                                {events?.length > 0 ? (
                                    events?.map((item, index) => (
                                        <tr
                                            key={`row-#${index}-${item?.id}`}
                                            onClick={() => fetchEventById(item?.uuid)}
                                        >
                                            <td>{item?.id}</td>
                                            <td>{item?.uuid}</td>
                                            <td>{item?.name}</td>
                                            <td>{item?.color}</td>
                                            <td>{moment(new Date(item?.startDate)).calendar()}</td>
                                            <td>{moment(new Date(item?.endDate)).calendar()}</td>
                                            <td>{item?.subscribers}</td>
                                            <td>{item?.details}</td>
                                            <td>{item?.priority}</td>
                                            <td>{moment(new Date(item?.createdAt)).calendar()}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <td
                                        style={{ fontSize: '1.2rem', fontWeight: '600' }}
                                        colSpan={10}
                                    >
                                        No data...
                                    </td>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
